import { clientUserSchema, clientUsersListSchema } from '@k2/common/users-state/normalizer-schemas';

export const clientAdminSchema = clientUserSchema;
export const clientAdminsListSchema = clientUsersListSchema;
